import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../shared/apiRoutes";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { getProductDetailsType, discountApiRes, claimOfferApiRes } from "../../components/sellScreen/productDetailsModule";

interface commonType {
    loading: boolean,
    error: string,
}

export interface getOnePosProductType { locationId: number }

interface DiscountDetails {
    automatic: {
        discountId?: string | number;
        isCategory: boolean;
    } | [];
    buyXgetY: {
        discountId?: string | number;
        isCategory: boolean;
    } | [];
}

interface Payload {
    storeId: string | number | undefined;
    locationId: string | number | undefined;
    timeZone: string;
    industryName: string | undefined;
    discountDetails: DiscountDetails;
    isCart: boolean;
    currentDate: Date;
}

interface updateCartPayload {
    productId: number,
    isPos: true
    variantId: number,
    quantity: number,
    isUpdateCartQty: true,
}

interface IntialValueProps {
    loading: boolean,
    error: string,
    getOnePosProduct: commonType & { value: getProductDetailsType | null }
    getProductDiscount: commonType & { value: discountApiRes | null }
    getCartProduct: commonType & { value: claimOfferApiRes | null }
}

const initialState: IntialValueProps = {
    loading: true,
    error: '',
    getOnePosProduct: { value: null, loading: true, error: "" },
    getProductDiscount: { value: null, loading: true, error: "" },
    getCartProduct: { value: null, loading: true, error: "" }
}

export const getOnePosProduct = createAsyncThunk("productDetails/getOnePosProductForSellScreen", ({ storeId, productId, locationId }: { storeId: number, productId: number, locationId: getOnePosProductType }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOnePosProductForSellScreen, { storeId: storeId, productId: productId })
    return HttpRoutingService?.getMethod<getProductDetailsType>(url, locationId)
})

export const getOnePosProductDiscount = createAsyncThunk("productDetails/getOnePosProductDiscount", ({ storeId, productId, variantId, locationId }: { storeId: number, productId: number, variantId: number, locationId: getOnePosProductType }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOnePosProductDiscount, { storeId: storeId, productId: productId, variantId: variantId })
    return HttpRoutingService?.getMethod<discountApiRes>(url, locationId)
})

export const getAuthorizedCartProduct = createAsyncThunk("productDetails/getAuthorizedCartProduct", ({ storeId, customerId, data }: { storeId: number, customerId: number, data: Payload }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAuthorizedCartProduct, { storeId: storeId, customerId: customerId })
    return HttpRoutingService?.getMethod<claimOfferApiRes>(url, data, "v1/")
})

export const productDetailsSlice = createSlice({
    name: "productDetails",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOnePosProduct?.pending, (state) => {
                state.getOnePosProduct.loading = true
            })
            .addCase(getOnePosProduct?.fulfilled, (state, action) => {
                state.getOnePosProduct.loading = false
                state.getOnePosProduct.value = action?.payload
            })
            .addCase(getOnePosProduct?.rejected, (state, action) => {
                state.getOnePosProduct.loading = false
                state.getOnePosProduct.error = action?.error?.message as string
            })
            .addCase(getOnePosProductDiscount?.pending, (state) => {
                state.getProductDiscount.loading = true
            })
            .addCase(getOnePosProductDiscount?.fulfilled, (state, action) => {
                state.getProductDiscount.loading = false
                state.getProductDiscount.value = action?.payload
            })
            .addCase(getOnePosProductDiscount?.rejected, (state, action) => {
                state.getProductDiscount.loading = false
                state.getProductDiscount.error = action?.error?.message as string
            })
            .addCase(getAuthorizedCartProduct?.pending, (state) => {
                state.getCartProduct.loading = true
            })
            .addCase(getAuthorizedCartProduct?.fulfilled, (state, action) => {
                state.getCartProduct.loading = false
                state.getCartProduct.value = action?.payload
            })
            .addCase(getAuthorizedCartProduct?.rejected, (state, action) => {
                state.getCartProduct.loading = false
                state.getCartProduct.error = action?.error?.message as string
            })
    }
})

export default productDetailsSlice?.reducer